import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { BannerComponent, ButtonComponent } from '@mode/capra';
import { CalendlyPopupButtonComponent } from '../calendly-popup-button/calendly-popup-button.component';

@Component({
  standalone: true,
  selector: 'mode-studio-seat-limit-banner',
  imports: [BannerComponent, ButtonComponent, CalendlyPopupButtonComponent, CommonModule],
  templateUrl: './studio-seat-limit-banner.component.html',
  styleUrls: ['./studio-seat-limit-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StudioSeatLimitBannerComponent implements OnInit {
  numberOfSeats = 3;
  warningText?: string;
  tipMessage?: string;

  @Input()
  paidPlan = false;

  ngOnInit() {
    this.warningText = this.paidPlan
      ? 'Your workspace has reached the maximum number of users.'
      : `You've hit your ${this.numberOfSeats} seat limit. Upgrade to bring your teams on board.`;
    this.tipMessage = this.paidPlan
      ? 'Upgrade now to bring the rest of your team on board.'
      : 'Mode Business plans let teams tailor the number of seats to their needs. Upgrade today!';
  }
}
